<template>
    <div id="site-wrapper">
        <router-view></router-view>
    </div>

    <alert-display :isError="true" :msg="$store.state.errorMsg" />
    <alert-display :isError="false" :msg="$store.state.validationMsg" />
</template>

<script>
export default {
    data() {
        return {
            
        }
    },
};
</script>